import React, { useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Whisper, Popover } from "rsuite";
import { FaRegCalendarAlt, FaRegEdit, FaRegEye } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import AddDistributorModel from "../../ClinicModal/AddDistributorModel";
import Offcanvas from "react-bootstrap/Offcanvas";

// Dummy data for the inventory
const inventoryData = [
  {
    id: 1,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "TEEM 40MG TAB",
    company: "Esteem Pharma",
    category: "-",
    mrp: 70.31,
    ptr: 55.50,
    scheme: "-",
    disc: "-",
    margin: "11.59%",
    status: "available"
  },
  {
    id: 2,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "DULCOFLEX TAB",
    company: "Sanofi Synthelabo India Pvt Ltd",
    category: "-",
    mrp: 12.38,
    ptr: 9.90,
    scheme: "-",
    disc: "-",
    margin: "10.44%",
    status: "available"
  },
  {
    id: 3,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "CALCIDOL M TAB",
    company: "Profess Health Products Pvt Ltd",
    category: "-",
    mrp: 248.44,
    ptr: 194.01,
    scheme: "-",
    disc: "-",
    margin: "12.54%",
    status: "available"
  },
  {
    id: 4,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "GZOR M2 TAB",
    company: "Lloyd Healthcare Pvt Ltd",
    category: "-",
    mrp: 146.16,
    ptr: 111.37,
    scheme: "-",
    disc: "-",
    margin: "14.66%",
    status: "low-stock"
  },
  {
    id: 5,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "CADOMER OINT 10GM",
    company: "Jbcl Chemical And Pharma",
    category: "-",
    mrp: 232.89,
    ptr: 177.44,
    scheme: "-",
    disc: "-",
    margin: "14.67%",
    status: "available"
  },
  // Adding more dummy data to demonstrate scrolling
  {
    id: 6,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "PARACETAMOL 500MG",
    company: "Generic Pharma Ltd",
    category: "-",
    mrp: 25.50,
    ptr: 20.00,
    scheme: "-",
    disc: "-",
    margin: "15.50%",
    status: "available"
  },
  {
    id: 7,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "OMEPRAZOLE 20MG",
    company: "MedCore Industries",
    category: "-",
    mrp: 89.75,
    ptr: 72.50,
    scheme: "-",
    disc: "-",
    margin: "12.25%",
    status: "low-stock"
  },
  {
    id: 8,
    image: "https://media.istockphoto.com/id/1300036753/photo/falling-antibiotics-healthcare-background.jpg?s=612x612&w=0&k=20&c=oquxJiLqE33ePw2qML9UtKJgyYUqjkLFwxT84Pr-WPk=",
    product: "AZITHROMYCIN 250MG",
    company: "PharmaTech Solutions",
    category: "-",
    mrp: 156.20,
    ptr: 125.00,
    scheme: "-",
    disc: "-",
    margin: "13.85%",
    status: "available"
  }
];

const ActionCellDistributor = ({ data }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const triggerRef = useRef(null);

  const closePopover = () => {
    if (triggerRef.current) {
      triggerRef.current.close();
    }
  };

  const handleViewClick = () => {
    setShowOffcanvas(true);
    closePopover();
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-48">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={() => {
          setOpen(true);
          closePopover();
        }}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEdit className="text-sm text-[#55c999]" />
        <span>Edit</span>
      </div>

      <div
        onClick={handleViewClick}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <FaRegEye className="text-sm text-[#383838]" />
        <span>View</span>
      </div>
    </Popover>
  );

  return (
    <>
      <AddDistributorModel
        isOpen={open}
        onClose={() => setOpen(false)}
        editData={data}
        isEditMode={true}
      />

      {/* Inventory Offcanvas */}
      <Offcanvas 
        show={showOffcanvas} 
        onHide={() => setShowOffcanvas(false)} 
        placement="end"
        style={{ width: '900px' }}
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title className="fw-bold">
            Distributor Inventory - {data?.distributorName || 'Distributor Name'}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0 d-flex flex-column h-100">
          {/* Header Info - Fixed */}
          <div className="p-3 border-bottom bg-white">
            <h6 className="text-muted mb-0">Total Products: {inventoryData.length}</h6>
          </div>
          
          {/* Table Container - Scrollable - Takes full remaining height */}
          <div className="flex-grow-1 position-relative">
            {/* Fixed Header */}
            <div className="position-sticky top-0 bg-white border-bottom" style={{ zIndex: 10 }}>
              <table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: '60px' }}></th>
                    <th style={{ width: '250px',fontSize:14,fontWeight:500 }}>PRODUCT</th>
                    <th style={{ width: '120px',fontSize:14,fontWeight:500 }}>CATEGORY</th>
                    <th className="text-end" style={{ width: '80px',fontSize:14,fontWeight:500 }}>MRP</th>
                    <th className="text-end" style={{ width: '80px',fontSize:14,fontWeight:500 }}>PTR</th>
                    <th className="text-center" style={{ width: '80px',fontSize:14,fontWeight:500 }}>SCHEME</th>
                    <th className="text-center" style={{ width: '80px',fontSize:14,fontWeight:500 }}>DISC</th>
                    <th className="text-end" style={{ width: '90px',fontSize:14,fontWeight:500 }}>MARGIN</th>
                  </tr>
                </thead>
              </table>
            </div>
            
            {/* Scrollable Table Body */}
            <div 
              className="overflow-auto"
              style={{ 
                height: 'calc(100vh - 200px)', // Adjusted height without summary card
                minHeight: '400px',
                scrollbarWidth: 'thin',
                scrollbarColor: '#cbd5e0 #f7fafc'
              }}
            >
              <table className="table table-hover align-middle mb-0">
                <tbody>
                  {inventoryData.map((item) => (
                    <tr key={item.id}>
                      <td style={{ width: '60px' }}>
                        <div className="d-flex align-items-center justify-content-center">
                          <div 
                            className="rounded border d-flex align-items-center justify-content-center overflow-hidden"
                            style={{ 
                              width: '40px', 
                              height: '40px',
                              backgroundColor: '#f8f9fa'
                            }}
                          >
                            <img 
                              src={item.image} 
                              alt={item.product}
                              style={{
                                width: '40px',
                                height: '40px',
                                objectFit: 'cover'
                              }}
                            />
                          </div>
                        </div>
                      </td>
                      <td style={{ width: '250px' }}>
                        <div>
                          <div className="fw-bold text-dark mb-0" style={{fontSize:14}}>
                            {item.product}
                          </div>
                          <small className="text-muted">{item.company}</small>
                        </div>
                      </td>
                      <td className="text-muted" style={{ width: '120px',fontSize:14 }}>-</td>
                      <td className="text-end fw-semibold" style={{ width: '80px',fontSize:14 }}>₹{item.mrp}</td>
                      <td className="text-end fw-semibold" style={{ width: '80px',fontSize:14 }}>₹{item.ptr}</td>
                      <td className="text-center text-muted" style={{ width: '80px',fontSize:14 }}>-</td>
                      <td className="text-center text-muted" style={{ width: '80px',fontSize:14 }}>-</td>
                      <td className="text-end" style={{ width: '90px' }}>
                        <span className="badge bg-light text-dark border">
                          {item.margin}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Whisper
        ref={triggerRef}
        placement="topEnd"
        trigger="click"
        speaker={renderPopover}
      >
        <button
          className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
          title="More actions"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="lucide lucide-ellipsis h-4 w-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 24 24"
          >
            <circle cx="12" cy="12" r="1"></circle>
            <circle cx="19" cy="12" r="1"></circle>
            <circle cx="5" cy="12" r="1"></circle>
          </svg>
        </button>
      </Whisper>
    </>
  );
};

export default ActionCellDistributor;
